/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

export default angular.module('tektelic.api.gateway', [])
    .factory('gatewayService', GatewayService)
    .name;

/*@ngInject*/
function GatewayService($http, $q, types, wsSubscriptionService) {

    var service = {
        deleteGateway: deleteGateway,
        deleteSystemGateway: deleteSystemGateway,
        getGateway: getGateway,
        saveGateway: saveGateway,
        saveGatewayMassCommissioning: saveGatewayMassCommissioning,
        enableGateway: enableGateway,
        disableGateway: disableGateway,
        getGatewayGroupGateways: getGatewayGroupGateways,
        assignGatewayToCustomer: assignGatewayToCustomer,
        unassignGatewayFromCustomer: unassignGatewayFromCustomer,
        subscribeForGatewayStateData: subscribeForGatewayStateData,
        subscribeForGatewayStatsData: subscribeForGatewayStatsData,
        getSystemGatewayByMac: getSystemGatewayByMac
    };

    return service;

    function getGatewayGroupGateways (gatewayGroupId) {
        var deferred = $q.defer();
        $http.get(`/api/gatewayGroup/${gatewayGroupId}/gateways`, null).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function getGateway (gatewayId) {
        var deferred = $q.defer();
        var url = '/api/gateway/' + gatewayId;
        $http.get(url, null).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function saveGateway (gateway) {
        var deferred = $q.defer();
        var url = '/api/gateway';
        $http.post(url, gateway).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function saveGatewayMassCommissioning(gateway) {
        var deferred = $q.defer();
        var url = '/api/gateway';
        $http.post(url, gateway, {ignoreErrors: true}).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail(rejection) {
            deferred.reject(rejection);
        });
        return deferred.promise;
    }

    function enableGateway (gatewayId) {
        var deferred = $q.defer();
        var url = `/api/gateway/${gatewayId}/enable`;
        $http.post(url).then(function success() {
            deferred.resolve();
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function disableGateway (gatewayId) {
        var deferred = $q.defer();
        var url = `/api/gateway/${gatewayId}/disable`;
        $http.post(url).then(function success() {
            deferred.resolve();
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function deleteGateway (gatewayId) {
        var deferred = $q.defer();
        var url = '/api/gateway/' + gatewayId;
        $http.delete(url).then(function success() {
            deferred.resolve();
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function deleteSystemGateway(gatewayId) {
        var deferred = $q.defer();
        var url = '/api/system/gateway/' + gatewayId;
        $http.delete(url).then(function success() {
            deferred.resolve();
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function assignGatewayToCustomer(customerId, gatewayId) {
        var deferred = $q.defer();
        var url = `/api/customer/${customerId}/gateway/${gatewayId}`;
        $http.post(url).then(function success() {
            deferred.resolve();
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function unassignGatewayFromCustomer(gatewayId) {
        var deferred = $q.defer();
        var url = `/api/customer/gateway/${gatewayId}`;
        $http.delete(url).then(function success() {
            deferred.resolve();        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function subscribeForGatewayStateData(gatewayId, onData) {
        var subscriptionCommand = {
            entityType: types.entityType.gateway,
            entityId: gatewayId,
            type: types.wsSubscriptionType.state
        };
        var subscriber = {
            subscriptionCommand: subscriptionCommand,
            onData: function (data) {
                if (data.data) {
                    onData(data.data);
                }
            }
        };
        return wsSubscriptionService.subscribe(subscriber);
    }

    function subscribeForGatewayStatsData(gatewayId, timewindow, onData, onReconnected) {

        var subscriptionCommand = {
            entityType: types.entityType.gateway,
            entityId: gatewayId,
            type: types.wsSubscriptionType.stats
        };
        if (timewindow.history.timewindowMs) {
            subscriptionCommand.timeWindow = timewindow.history.timewindowMs;
            subscriptionCommand.startTs = 0;
            subscriptionCommand.endTs = 0;
        } else {
            subscriptionCommand.startTs = timewindow.history.fixedTimewindow.startTimeMs;
            subscriptionCommand.endTs = timewindow.history.fixedTimewindow.endTimeMs;
            subscriptionCommand.timeWindow = 0;
        }
        var subscriber = {
            subscriptionCommand: subscriptionCommand,
            onData: function (data) {
                if (data.data) {
                    onData(data.data);
                }
            },
            onReconnected: function () {
                if (onReconnected) {
                    onReconnected();
                }
            }
        };
        return wsSubscriptionService.subscribe(subscriber);
    }

    function getSystemGatewayByMac(gatewayMac) {
        var deferred = $q.defer();

        $http.get('/api/system/gateway/mac/' + gatewayMac).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });

        return deferred.promise;
    }
}



// WEBPACK FOOTER //
// ./src/app/api/gateway.service.js